import { render, staticRenderFns } from "./EmergenciaView.vue?vue&type=template&id=10ba3800"
import script from "./EmergenciaView.vue?vue&type=script&lang=js"
export * from "./EmergenciaView.vue?vue&type=script&lang=js"
import style0 from "./EmergenciaView.vue?vue&type=style&index=0&id=10ba3800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports